const ENV = {}

// Import variables if present (from env.js)
if (window) {
  Object.assign(ENV, window.__env) // eslint-disable-line no-underscore-dangle
}

export default ENV
